import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import ScriptLoaderUtil from '../../util/ScriptLoaderUtil';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { EventActions } from '../../enums/AnalyticsEnums';
export const SIZEBAY_SCRIPT_KEY = 'sizebay-script';
export const SIZEBAY_CONTAINER_ID = 'sizebay-container';
const SIZEBAY_RENDERED_EVENT = 'sizebay:rendered';
const SIZEBAY_WIDGET_BUTTON_ID = 'szb-vfr-button';
const SIZEBAY_CHART_BUTTON_ID = 'szb-chart-button';
export const SizebayContainer = () => {
    const { sizebayScript } = useAemConfig();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!sizebayScript) {
            return;
        }
        ScriptLoaderUtil.loadScript(sizebayScript, SIZEBAY_SCRIPT_KEY);
        window.addEventListener(SIZEBAY_RENDERED_EVENT, () => {
            const widgetButton = document.getElementById(SIZEBAY_WIDGET_BUTTON_ID);
            const chartButton = document.getElementById(SIZEBAY_CHART_BUTTON_ID);
            if (widgetButton) {
                const widgetButtonClickHandler = () => {
                    dispatch(analyticsActions.sizebayClick(EventActions.SIZEBAY_WIDGET_CLICK));
                    widgetButton.removeEventListener('click', widgetButtonClickHandler);
                };
                widgetButton.addEventListener('click', widgetButtonClickHandler);
            }
            if (chartButton) {
                const chartButtonClickHandler = () => {
                    dispatch(analyticsActions.sizebayClick(EventActions.SIZEBAY_GUIDE_CLICK));
                    chartButton.removeEventListener('click', chartButtonClickHandler);
                };
                chartButton.addEventListener('click', chartButtonClickHandler);
            }
        });
    }, [sizebayScript]);
    if (!sizebayScript) {
        return null;
    }
    return _jsx("div", { id: SIZEBAY_CONTAINER_ID });
};
